import { SheetClose, SheetContent, SheetTitle } from "@/components/ui/sheet";
import { navItems } from "@/config/nav-items";
import Link from "next/link";
import { usePathname } from "next/navigation";
import React from "react";
import Image from "next/image";
import { BsTwitterX } from "react-icons/bs";
import { motion } from "framer-motion";
import { RiTelegram2Line } from "react-icons/ri";
import { Pill } from "lucide-react";

export default function MobileNavbar() {
  const pathName = usePathname();

  return (
    <SheetContent side="left" className="h-full px-0 py-4 w-[270px] p-1">
      <SheetTitle className="h-auto py-2 ml-6">
        <Link
          href="/"
          className="text-[#ACFF33] inline-flex items-center gap-x-2 text-2xl font-bold"
        >
          {/* alerts.ai */}
          <Image
            src="/logo.png"
            alt="alerts.ai logo"
            width={180}
            height={40}
            className="w-[80%]"
          />
        </Link>
      </SheetTitle>
      <div className="h-[91%] flex flex-col justify-between py-2 overflow-y-scroll px-2">
        <div className="flex flex-col gap-1.5 pb-5 ">
          {navItems.map((item, index) => (
            <SheetClose
              key={index}
              asChild
              className={`w-full rounded-md hover:bg-indigo-200/90 hover:text-neutral-800  py-2.5 px-6 text-base
                                ${
                                  item.href === pathName
                                    ? "bg-indigo-500 text-gray-50"
                                    : ""
                                }
                            `}
            >
              <motion.div
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <Link
                  href={item.href}
                  className="flex items-center justify-start gap-2 "
                >
                  {typeof item.icon === "string" ? (
                   <Pill />
                  ) : (
                    React.createElement(
                      item.icon as React.ComponentType<{ className?: string }>,
                      { className: "w-5 h-5" }
                    )
                  )}
                  {item.label}
                </Link>
              </motion.div>
            </SheetClose>
          ))}
        </div>
        <div className="flex flex-col items-start justify-center gap-1">
          <h5 className="text-indigo-600 font-semibold">Join Community :</h5>
          <div className="flex items-center gap-4">
            <Link href={"https://x.com/CatDevAi"} className="items-center">
              <button className="text-black/80 px-2 py-2 rounded-lg">
                <BsTwitterX className="w-5 h-5" />
              </button>
            </Link>
            <Link href={"https://t.me/CatDevAi"} className="items-center">
              <button className="text-black/80 px-2 py-1.5 rounded-lg">
                <RiTelegram2Line className="w-6 h-6" />
              </button>
            </Link>
          </div>
        </div>
      </div>
    </SheetContent>
  );
}
